export default __webpack_public_path__ + "static/media/hoppia_about_03.9b62e297.png";